import { NgModule } from "@angular/core";
import { MatRadioModule } from "@angular/material/radio";
import { FuseSharedModule } from "@fuse/shared.module";
import { CourierPartnerChargesComponent } from "./courier-partner-charges.component";
import { MatTableModule } from "@angular/material/table";
import { MatIconModule } from "@angular/material/icon";
import { PipesModule } from "../../pipes/pipes.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSortModule } from "@angular/material/sort";

@NgModule({
  declarations: [CourierPartnerChargesComponent],
  imports: [
    // shared
    FuseSharedModule,
    PipesModule,

    // material
    MatTableModule,
    MatIconModule,
    MatRadioModule,
    MatTooltipModule,
    MatSortModule
  ],
  exports: [CourierPartnerChargesComponent]
})
export class CourierPartnerChargesModule {}
